import React from "react";
import "../../zisComponents/grid/Grid.scss";
import "./Spotreba.scss";
import { GridDetailRow } from "@progress/kendo-react-grid";

export default function Detail(categories) {
  return class extends GridDetailRow {
    render() {
      const { dataItem } = this.props;

      return (
        <>
          {dataItem && (
            <>
              {/* RENDER CATEGORIES */}
              <div className="row m-0">
                <div className="col-1 p-0 gridDetailCol spotreba-gridDetailCol" />
                <div className="col-11 p-0 gridDetailCol spotreba-gridDetailCol">
                  <div className="row m-0">
                    {categories.map((c, key) => (
                      <div className="col-1 p-0 gridDetailCol spotreba-gridDetailCol" key={key}>
                        {c}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* RENDER DATA OF CURR YEAR */}
              {dataItem.SPOTREBA && dataItem.SPOTREBA.currYear && (
                <div className="row m-0">
                  <div className="col-1 p-0 gridDetailCol spotreba-gridDetailCol">
                    {dataItem.SPOTREBA.currYear.yearName}
                  </div>
                  <div className="col-11 p-0 gridDetailCol spotreba-gridDetailCol">
                    <div className="row m-0">
                      {dataItem.SPOTREBA.currYear.data.map((d, key) => {
                        return (
                          <div className="col-1 p-0 gridDetailCol spotreba-gridDetailCol" key={key}>
                            {d || "-"}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {/* RENDER DATA OF LAST YEAR */}
              {dataItem.SPOTREBA && dataItem.SPOTREBA.lastYear && (
                <div className="row m-0">
                  <div className="col-1 p-0 gridDetailCol spotreba-gridDetailCol">
                    {dataItem.SPOTREBA.lastYear.yearName}
                  </div>
                  <div className="col-11 p-0 gridDetailCol spotreba-gridDetailCol">
                    <div className="row m-0">
                      {dataItem.SPOTREBA.lastYear.data.map((d, key) => {
                        return (
                          <div className="col-1 p-0 gridDetailCol spotreba-gridDetailCol" key={key}>
                            {d || "-"}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      );
    }
  };
}
